import BnumElement from 'components/bnum-element';

export function Light() {
  return function (target: Function, context: ClassDecoratorContext) {
    if (context.kind !== 'class') {
      throw new Error('@Light ne peut être utilisé que sur une classe.');
    }

    if (!(target.prototype instanceof BnumElement))
      throw new Error(
        '@Light ne peut être utiliser sur une classe qui hérite de BnumElement',
      );

    context.addInitializer(function () {
      (this as any).__CONFIG_SHADOW__ = false;
    });
  };
}
